const publicUrl = process.env.PUBLIC_URL || "";

export const assetPath = (path) => `${publicUrl}/${path.replace(/^\/+/, "")}`;
